import React, { Suspense } from "react";

class Boundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("Route failed to load:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="max-w-xl mx-auto px-4 py-24 text-center font-sans">
        <h1 className="text-2xl font-semibold mb-3">This page could not be loaded</h1>
        <p className="text-slate-600 mb-6">Please check your connection and try again.</p>
        <a href="/" className="inline-block px-5 py-2.5 bg-slate-900 text-white rounded">
          Back to Neuracraft home
        </a>
      </div>
    );
  }
}

export default function RouteBoundary({ children }) {
  return (
    <Boundary>
      <Suspense fallback={<div className="min-h-[50vh]" aria-busy="true" />}>{children}</Suspense>
    </Boundary>
  );
}
